import type { HelpFile } from '../../types/help'
import { JobDetailTestIds } from '../../../testids/JobDetailTestIds'

export const jobDetailHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [JobDetailTestIds.jobDetailTitle]:
      'Hintergrundprozesse führen geplante oder bedarfsgesteuerte Systemwartung, Datenverarbeitung und Integrations-Workflows aus.',
    [JobDetailTestIds.sectionConfiguration]:
      'Cron-Zeitplan, Log-Level und Einstellungen, die steuern, wann und wie dieser Job läuft.',
    [JobDetailTestIds.sectionTasks]:
      'Geordnete Liste der Aufgaben dieses Jobs — jede kann ein Skript, ein SQL-Block oder ein eingebauter Konnektorschritt sein.',
    [JobDetailTestIds.sectionRecentExecutions]:
      'Jüngste Ausführungen dieses Jobs mit Status und Dauer.',
    [JobDetailTestIds.scheduleEditForm]:
      'Cron-Ausdruck, Log-Level und Aktiv-Schalter bearbeiten — Änderungen werden ab dem nächsten Scheduler-Tick wirksam.',
    [JobDetailTestIds.inputCron]:
      'Cron-Ausdruck für automatische Ausführungen — leer lassen, um geplante Läufe zu deaktivieren.',
    [JobDetailTestIds.selectLogLevel]:
      'Detailgrad der Log-Ausgabe — DEBUG protokolliert alles, ERROR nur Fehler.',
    [JobDetailTestIds.switchEnabled]:
      'Gibt an, ob dieser Job nach Zeitplan läuft — deaktivierte Jobs lassen sich weiterhin manuell auslösen.',
    [JobDetailTestIds.btnRunNow]:
      'Sofortige Ausführung dieses Jobs auslösen, unabhängig vom Cron-Zeitplan.',
    [JobDetailTestIds.btnEditSchedule]: null,
    [JobDetailTestIds.btnEditTasks]: null,
    [JobDetailTestIds.btnDeleteJob]:
      'Diesen Job und seine Ausführungshistorie dauerhaft löschen — nicht rückgängig zu machen.',
    [JobDetailTestIds.btnScheduleSave]: null,
    [JobDetailTestIds.btnScheduleCancel]: null,
    [JobDetailTestIds.btnConfirmRemoveSchedule]:
      'Cron-Zeitplan entfernen — der Job läuft danach nur noch manuell ausgelöst.',
    [JobDetailTestIds.btnCancelRemoveSchedule]: null,
    [JobDetailTestIds.linkViewAllExecutions]:
      'Vollständige Ausführungshistorie dieses Jobs öffnen, inklusive älterer Läufe.',
  },
}
